import {
  init,
  loaderRunner,
  redirectToUserPrefix,
  termsOfService,
  userChecks,
} from "./helpers";
export const adminLoader = async () => {
  return loaderRunner([
    await init(),
    await userChecks(),
    termsOfService(),
    await redirectToUserPrefix("/admin"),
  ]);
};
